import { useState } from "react";
import { Row } from "../../../../components/Row";
import { Input } from "../../../../components/Input";
import { Select } from "../../../../components/Select";
import { Button, ChevronIcon, Content, Divider, Field, Label, Toggle } from "../../../../components/Forms";
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from "react-icons/ai";
import { Accordion } from "../../../../components/Accordion";
import {indices} from "../../../../mocks/indices"
import types from "../../../../mocks/types_rules"
import { TreeSelect } from "../../../../components/TreeSelect";
import useAnalyticsEventTracker from '../../../../hooks/useAnalyticsEventTracker';

interface paramsProps {
  formAttr?: any;
  submit(value: any, page: number): void;
  initialSearch?: string
}

export function Form({ formAttr, submit, initialSearch = "" }: paramsProps) {
  const gaEventTracker = useAnalyticsEventTracker('Rules Form');

  const [initialType, setInitialType] = useState('text');
  const [finalType, setFinalType] = useState('text');

  const [mainSearch, setMainSearch] = useState('');
  const [initialDate, setInitialDate] = useState('');
  const [finalDate, setFinalDate] = useState('');

  // const mapType = mapInitialSearch(initialSearch);
  const [type, setType] = useState(initialSearch);
  const [index, setIndex] = useState('');

  const typeOptions: any[] = types; //getOptions(formAttr?.type);
  //const indexOptions: string[] = indices; //getOptions(formAttr?.index);

  const [isFormOpen, setIsFormOpen] = useState(false);

  // function getOptions(component: { options: { options: string[]; }; }) {
  //   if (!component?.options?.options?.length) return [];
  //   return component?.options?.options;
  // }

  async function onSubmit(e: any) {
    e.preventDefault();
    const searchTemp = {
      search_text: mainSearch,
      initialDate: initialDate as string,
      finalDate: finalDate as string,
      type: type,
      index: index
    };
    gaEventTracker('submit', JSON.stringify(searchTemp))
    await submit(searchTemp, 1);
  }

  return (
    <>
      <Toggle onClick={() => setIsFormOpen(!isFormOpen)} customWidth="calc(100% - 54px)" margin="auto">
        <span>Pesquisar</span>
        <AiOutlinePlusSquare display={!isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
        <AiOutlineMinusSquare display={isFormOpen? 'block' : 'none'} size={28} cursor={'pointer'} />
      </Toggle>
      <Accordion isOpen={isFormOpen} hasBorder={false} margin="0" customWidth="calc(46% - 12px)">
        <Content
          onSubmit={onSubmit}
        >
          <Label>Busca Livre</Label>
          <Input
            type="text"
            placeholder="Pesquisar"
            marginBottom="16px"
            value={mainSearch}
            onChange={(value: any) => setMainSearch(value)}
          />
          <Label>Data da Promulgação</Label>
          <Row breakOnMobile={false}>
            <Field marginBottom="6px">
              <Input
                type={initialType}
                placeholder="Inicial"
                onFocus={() => setInitialType('date')}
                value={initialDate}
                onChange={(value: any) => setInitialDate(value)}
              />
            </Field>
            <Divider>A</Divider>
            <Field marginBottom="6px">
              <Input
                type={finalType}
                placeholder="Final"
                onFocus={() => setFinalType('date')}
                value={finalDate}
                onChange={(value: any) => setFinalDate(value)}
              />
            </Field>
          </Row>
          <Label>Tipo</Label>
          <Field marginBottom="16px">
            <Select
              value={type}
              onChange={(value: any) => setType(value)}
            >
              <option value={''}>Selecionar</option>
              {typeOptions.map((type: any) => (
                <option value={type.value}>{type.option}</option> 
              ))}
            </Select>
            <ChevronIcon size={24} />
          </Field>
          <Label>Índice</Label>
          <Field marginBottom="16px">
            <TreeSelect 
              data={indices} 
              marginBottom="0px"
              dropdownMaxHeight="350px"
              value={index}
              onChange={(value: any) => setIndex(value)}
            />
            <ChevronIcon size={24} />
          </Field>
          <Button>Pesquisar</Button>
        </Content>
      </Accordion>
    </>
  );
}
